module.exports = require('expo-router/entry')
